var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.678395 7.44298C2.71173 4.52834 5.34817 3 7.98941 3C11.0914 3 13.7635 5.02086 15.34 7.45575L15.3408 7.4569C15.4451 7.619 15.5006 7.8077 15.5006 8.00047C15.5006 8.19289 15.4453 8.38125 15.3414 8.54315C13.7662 11.0094 11.1114 13 7.98941 13C4.8342 13 2.23054 11.0135 0.659261 8.55448C0.552495 8.38869 0.497119 8.19503 0.500115 7.99784C0.503119 7.80016 0.564651 7.60781 0.676935 7.44509L0.678395 7.44298ZM1.5 8.01304L1.50139 8.0152C2.95267 10.287 5.27876 12 7.98941 12C10.6697 12 13.0459 10.2797 14.4989 8.00433L14.4999 8.00284C14.5004 8.00213 14.5006 8.00131 14.5006 8.00047C14.5006 8.00012 14.5005 7.99977 14.5005 7.99943C14.5004 7.999 14.5002 7.99858 14.5 7.9982C13.0414 5.7461 10.6457 4 7.98941 4C5.75997 4 3.40017 5.29037 1.5 8.01304Z",
    fill: "#5C6670"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6ZM5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8Z",
    fill: "#5C6670"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.4f73cb4bf36e2ce03be54fa547a9ae56.svg";
export { ForwardRef as ReactComponent };